import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("NewsCategoryConfigWidget", {
  title: "Configuration of event Categories",
  attributes: {
    body: {
      title: "News Categories",
    },
  },
  properties: ["body"],
});
